import React from "react";
import { Gift } from "lucide-react";
import HyvidRewardsTab from "./components/HyvidRewardsTab";
import ShortHeaderComponent from "../hyvid-awards/components/ShortHeaderComponent";

const HyvidRewards = () => {
  return (
    <div className="flex flex-col gap-6">
      <ShortHeaderComponent
        icon="Gift"
        title="Hyvid Rewards"
        description="Award gift credits and boost engagement across your team"
      />
      <HyvidRewardsTab/>
    </div>
  );
};

export default HyvidRewards;
